<script lang="ts">
    import type { TagNodeObject } from '$lib/bbcode/parser/types';
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';

    export let node: TagNodeObject;
</script>

<p class={`call-to-action-text`}>
    <BBCodeTree nodes={node.content} let:slotName let:slotContent>
        <slot {slotName} {slotContent} />
    </BBCodeTree>
</p>
